import type React from "react";

interface AthleteInfoProps {
  item: string;
  info: string;
  isLastItem: boolean;
}

export const AthleteInfo: React.FC<AthleteInfoProps> = ({ item, info, isLastItem }) => {
  return (
    <div className={`${isLastItem && "border-b"} border-t border-gray-200 border-solid grid grid-cols-2 py-1.5 w-full`}>
      <div className="col-span-1">
        <p className="text-xs text-[#808080] font-semibold">{item}</p>
      </div>
      <div className="col-span-1">
        <p className="text-xs text-[#808080] font-semibold">{info}</p>
      </div>
    </div>
  );
};
